// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__26O2k","productName":"Table_productName__1QJlY"};